import { Flex, Stack, Transition } from "@mantine/core";
import useLoginModalStore, { ELoginModalState } from "@store/loginModal.store";
import LoginModalBody from "./LoginModalBody";
import OTPModalBody from "./OTPModalBody";
import RegisterModalBody from "./RegisterModalBody";

const AuthPage = () => {
  const { state } = useLoginModalStore();

  return (
    <Flex align={"center"} className="relative h-full w-full">
      <Transition
        mounted={state === ELoginModalState.LOGIN}
        transition="slide-right"
        duration={200}
        timingFunction="ease"
      >
        {(styles) => (
          <Stack
            style={styles}
            justify="space-between"
            className="absolute h-full w-full overflow-y-visible"
          >
            <LoginModalBody />
          </Stack>
        )}
      </Transition>
      <Transition
        mounted={state === ELoginModalState.REGISTER}
        transition="slide-left"
        duration={200}
        timingFunction="ease"
      >
        {(styles) => (
          <Stack
            style={styles}
            justify="space-between"
            className="absolute h-full w-full overflow-y-visible"
          >
            <RegisterModalBody />
          </Stack>
        )}
      </Transition>
      <Transition
        mounted={state === ELoginModalState.OTP}
        transition="slide-left"
        duration={200}
        timingFunction="ease"
      >
        {(styles) => (
          <Stack
            style={styles}
            justify="space-between"
            className="absolute h-full w-full overflow-y-visible"
          >
            <OTPModalBody />
          </Stack>
        )}
      </Transition>
    </Flex>
  );
};

export default AuthPage;
